<mat-form-field [ngClass]="activeClass">
  @if (label) {
    <mat-label class="vertical-align-center">
      @if (icon) {
        <ion-icon [name]="icon" />
      }
      <tidy-text [body]="label" />
    </mat-label>
  }
  <mat-select
    [(value)]="selected"
    (selectionChange)="onChange($event)"
    [disableOptionCentering]="true"
    >
    @if (items?.length > ENABLE_SEARCH_MIN_ITEMS) {
      <mat-option>
        <ngx-mat-select-search
          ngModel
          (ngModelChange)="searchItems($event)"
          [placeholderLabel]="searchPlaceholder"
          />
      </mat-option>
    }
    @for (item of listedItems; track item) {
      <mat-option [value]="item.value">
        {{ item.viewValue | translate }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
